<template>
  <div>
    <ejs-tooltip
      v-if="data.statusCampaignTranslated === 'Approved' || data.statusCampaignTranslated === 'Scheduled' || data.statusCampaignTranslated === 'Sent'"
      ref="tooltip"
      :before-render="setSelectedCampaign"
      :content="contentTemplate"
      :css-class="cssClass"
      position="BottomCenter"
      opens-on="Hover"
    >
      {{ data.statusCampaignTranslated }}
    </ejs-tooltip>
    <div v-if="data.statusCampaignTranslated !== 'Approved' && data.statusCampaignTranslated !== 'Scheduled' && data.statusCampaignTranslated !== 'Sent'">
      {{ data.statusCampaignTranslated }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      data: {},
      cssClass: 'customtip',
      contentTemplate (data) {
        return {
          template: Vue.component('StatusTooltipTemplate', {
            data () {
              return {
                data: {}
              }
            },
            mounted () {
              this.data = this.$store.getters.getGridSelectedCampaign
            },
            template: `<div>
                <p class="tooltip-title">{{data.statusCampaignTranslated}} 
                  <span v-if="data.scheduledBy !== null && data.statusCampaignTranslated === 'Scheduled'">by {{data.scheduledBy}}</span>
                  <span v-if="data.approvedBy !== null && data.statusCampaignTranslated === 'Approved'">by {{data.approvedBy}}</span>
                  <span v-if="data.scheduledBy !== null && data.statusCampaignTranslated === 'Sent'">by {{data.scheduledBy}}</span>
                </p>
                <span v-if="data.statusCampaignTranslated === 'Scheduled' || data.statusCampaignTranslated === 'Sent'">{{data.requestedDate | dateFormat}}</span>
                <span v-if="data.statusCampaignTranslated === 'Approved'">{{data.approvedDate | dateFormat}}</span>
              </div>`
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getGridSelectedCampaign'
    ])
  },
  methods: {
    setSelectedCampaign () {
      this.$store.commit('SET_GRIDSELECTEDCAMPAIGNS', this.data)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
